import { FollowerTemplateSchema, type FollowerTemplate } from '../../schemas/follower';
import { warlockBraccioDestroTemplate } from './warlock-braccio-destro';

/**
 * Template del **secondo emissario del Warlock** — *Un Giusto Sovrano*
 * (manuale V1, rr. 6113-6118).
 *
 * 7° template Follower (gemello di `warlock-braccio-destro`). Quando il
 * Warlock prende la mossa advanced *Un Giusto Sovrano* (advanced_6_10,
 * prereq Braccio Destro), può evocare un **secondo emissario del patrono**
 * con le stesse meccaniche del primo Braccio Destro ma scelte indipendenti
 * (manuale r. 6118: «Crealo come hai fatto col primo, poi scegli Abilità,
 * Ranghi e capacità utili extra derivanti da altre mosse [non per forza
 * le stesse dell'altro].»).
 *
 * **Pattern Q3=β** (decisione 2026-05-15): template **duplicato** con
 * `baseStats` condivisi via import. Costo extra ~30 LOC vs. alternativa
 * "template condiviso + override narrativeFieldId per-mossa". Vantaggi:
 *  - Esplicito: 2 mosse-source distinte producono 2 follower con scelte
 *    indipendenti e nomi distinti senza riferire la stessa entità del template.
 *  - Lo `id` del template è semanticamente collegato alla mossa
 *    (`warlock-un-giusto-sovrano`), aiutando il debugging.
 *  - I narrativeField references (`nome-emissario-2`, ecc.) sono espliciti
 *    e tracciabili.
 *
 * **Switching giornaliero "quale è attivo oggi"** (manuale r. 6118: «Ogni
 * volta che il sole tramonta devi decidere quale dei due servitori
 * appare»): runtime di sessione, Fase F. Lo schema corrente supporta 2
 * follower distinti in `Character.followers`; il flag "attivo oggi" sarà
 * `Character.activeFollowerIds` (SSOT FI-8 §6.3 D7) introdotto in Fase F.
 */
export const warlockUnGiustoSovranoTemplate: FollowerTemplate = FollowerTemplateSchema.parse({
  ...warlockBraccioDestroTemplate,
  id: 'warlock-un-giusto-sovrano',
  sourceMoveId: 'warlock.un-giusto-sovrano',
  label: 'Secondo Emissario (Un Giusto Sovrano)',
  primarySkillFromNarrativeField: {
    narrativeFieldId: 'abilita-primaria-2',
    rank: 1,
  },
  traitFromNarrativeFields: {
    traitId: 'un-giusto-sovrano-capacita',
    labelFieldId: 'capacita-utile-label-2',
    descriptionFieldId: 'capacita-utile-desc-2',
  },
  nameFromNarrativeField: 'nome-emissario-2',
  respawnRule:
    'Come il Braccio Destro: se non disponibile, torna al prossimo tramonto. Ogni tramonto il Warlock decide quale dei due emissari appare (regola runtime per modalità giocabile).',
});
